import React, { useState, useContext } from 'react'
import WellDone from "../images/wellDone.png"
import Check from "../images/check.png"
import Lottie from 'react-lottie';
import animationData from '../Lotties/confetti.json'
import {QuizContext} from "../Helpers/Contexts"
import {Questions} from "../Helpers/QuestionList"

function EndScreen(){
    const {name, setName, setGameState, score, setScore} = useContext(QuizContext);
    const startAgain = () => {
        setScore(0);
        setName("")
        setGameState("menu");
    }
    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
    };

    var fullName = name.split(' '),
    firstName = fullName[0];
    

    return(<div className="App">

      
       <div className="Anim">
        <Lottie  options={defaultOptions}/>
        </div>
         
        <div className="End">
            <img className="wellDone" src={WellDone} alt="Home Page Illustartion"></img>
            <img className="CheckIllustration" src={Check} alt="Home Page Illustartion"></img>
        </div>
        
        <h1 className="endTitle">Well Done {firstName}!</h1>
        <p className="subtitle"> {score}/{Questions.length} answered correctly
        <br></br>
        You have unlocked {score*0.25}hrs
        <br></br>
        access to CowMesh
        </p>

         <button className="nextButton" onClick={startAgain}>Redeem</button>


    </div>)
}

export default EndScreen;